import { account } from './account'
import { admin } from './admin'
import { auth } from './auth'
import { money } from './money'
import { payments } from './payments'

/**
 * Единая точка входа в API: `api.money.wallets()`, `api.auth.login(...)`.
 *
 * Сгруппировано по смыслу, а не по путям бекенда: экран думает
 * «мне нужны кошельки», а не «мне нужен GET /api/v1/wallets».
 */
export const api = { auth, account, money, admin, payments }

export type { HistoryFilter } from './money'
